(function ($) {
  'use strict';

  /**
   * Click Thru Link
   * ---
   * - Triggers click within an el
   * - Defaults to first link
   * - Supports multiple links inside el
   */

  $.fn.clickThruLink = function (args) {
    args = $.extend({
      target: 'a:first, button:first',
      ignore_els: '',
      selector: '',
    }, args );
    var $this = $(this);
    var $target = $this.find( args.target );
    var timestamp_down = 0;

    // Prep hover
    $target.attr( 'data-thru-target', true );

    // Add ignored class to ignored els
    if ( args.ignore_els !== '' ) {
      $this.find( args.ignore_els ).addClass( 'is-click-tru-ignored' );
    }

    // Start Interaction Timer
    $(document).on('mousedown.clickthru', args.selector, function () {
      timestamp_down = Date.now();
    });

    // Handle Click Thru
    $(document).on('mouseup.clickthru', args.selector, function (e) {
      var $click_target = $(this).find( args.target );
      var is_target_interactive = $( e.target )
        .is( 'a[href], button, input, select, textarea' );
      var is_ignored = false;

      if ( args.ignore_els !== '' ) {
        is_ignored = $( e.target ).is( args.ignore_els );
      }

      // Ensure:
      // - Target exists
      // - An interactive el is _not_ clicked
      // (Allows click on other buttons or links)
      if ( $click_target.length && ! is_target_interactive && ! is_ignored ) {
        var timestamp_up = Date.now();
        var is_mouse_interaction = (timestamp_up - timestamp_down) > 350;

        // Preserve pointer accessibility
        // - Allows selecting text, dragging images, etc.
        if ( is_mouse_interaction ) {
          return false;
        }

        // Trigger Click
        $click_target[0].click();
      }
    });

    return this;
  };

})(jQuery);
